import styled from "styled-components";

export const ExternalPaneTitle = styled.span`
  display: block;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  font-size: 1.3em;
  font-weight: 700;
  margin-bottom: 0.4em;
  letter-spacing: 0.03em;
`;
